export default function Before(props: any) {
    return (
        <svg width="151" height="218" viewBox="0 0 151 218" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M95.8064 61.428L116.735 54.1932C117.521 53.9217 117.799 52.9532 117.278 52.3061L108.038 40.8425C107.52 40.2001 106.524 40.2598 106.086 40.9594L94.3969 59.6577C93.797 60.6172 94.7369 61.7977 95.8064 61.428Z"
                fill="url(#paint0_linear_950_5864)"
                stroke="url(#paint1_linear_950_5864)"
                strokeWidth="0.4"
            />
            <circle
                cx="123.198"
                cy="4.01367"
                r="3.2"
                transform="rotate(-0.947326 123.198 4.01367)"
                fill="url(#paint2_linear_950_5864)"
                stroke="url(#paint3_linear_950_5864)"
                strokeWidth="0.4"
            />
            <circle
                cx="94.6742"
                cy="214.514"
                r="3.2"
                transform="rotate(-0.947326 94.6742 214.514)"
                fill="url(#paint4_linear_950_5864)"
                stroke="url(#paint5_linear_950_5864)"
                strokeWidth="0.4"
            />
            <circle
                cx="4.23938"
                cy="67.9893"
                r="3.2"
                transform="rotate(-0.947326 4.23938 67.9893)"
                fill="url(#paint6_linear_950_5864)"
                stroke="url(#paint7_linear_950_5864)"
                strokeWidth="0.4"
            />
            <path
                d="M148.882 129.634C149.094 129.493 149.135 129.217 149.121 128.955C149.107 128.675 149.026 128.316 148.892 127.896C148.625 127.054 148.13 125.917 147.452 124.57C146.096 121.874 143.994 118.308 141.469 114.509C138.944 110.71 136.469 107.392 134.508 105.098C133.528 103.952 132.672 103.056 131.998 102.483C131.663 102.197 131.363 101.984 131.11 101.862C130.874 101.748 130.604 101.678 130.392 101.819C130.179 101.961 130.139 102.236 130.153 102.499C130.167 102.779 130.248 103.137 130.381 103.557C130.649 104.4 131.144 105.537 131.821 106.883C133.178 109.58 135.279 113.146 137.805 116.945C140.33 120.744 142.805 124.062 144.766 126.356C145.746 127.502 146.602 128.398 147.276 128.971C147.611 129.257 147.91 129.47 148.163 129.592C148.4 129.706 148.67 129.775 148.882 129.634Z"
                fill="url(#paint8_linear_950_5864)"
                stroke="url(#paint9_linear_950_5864)"
                strokeWidth="0.4"
            />
            <defs>
                <linearGradient id="paint0_linear_950_5864" x1="76.1812" y1="64.714" x2="79.6031" y2="35.3458" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_950_5864" x1="87.8602" y1="68.1363" x2="80.9445" y2="59.16" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_950_5864" x1="126.198" y1="-2.54884" x2="130.888" y2="4.20783" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_950_5864" x1="122.782" y1="-0.870956" x2="126.652" y2="-0.750857" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_950_5864" x1="97.6742" y1="207.952" x2="102.364" y2="214.708" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_950_5864" x1="94.2579" y1="209.629" x2="98.1288" y2="209.75" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint6_linear_950_5864" x1="7.23938" y1="61.4267" x2="11.9292" y2="68.1834" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint7_linear_950_5864" x1="3.82307" y1="63.1046" x2="7.69395" y2="63.2247" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint8_linear_950_5864" x1="121.321" y1="84.5615" x2="129.994" y2="80.7526" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint9_linear_950_5864" x1="124.533" y1="93.5076" x2="126.689" y2="92.0857" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
